import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
declare var ace: any;
@pbi.Component({
    selector: 'infopublic',
    templateUrl: './infopublic.component.html',
    styleUrls: ['./infopublic.component.css']
})

export class InfoPublicComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Thông tin liên hệ";
    //#region InfoPublic
    Title: string = "";
    ID: string = "-1";
    NodeID: string = "";
    Name: string = "";
    HotLine: string = "";
    Phone0: string = "";
    Skype: string = "";
    Email: string = "";
    DiaChi: string = "";
    Active: boolean = false;
    Action: string = "";
    Logo: string = this.pb_func.NotImage;
    DelLogo: string = "";
    FileLogo: any = null;
    LinkOrg: string = "";
    //#endregion InfoPublic
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        var editModal = $('#EditInfoPublicModal');
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/global/plugins/jstree/dist/jstree.min.js',
            'assets/pages/scripts/ui-tree.min.js',
            'assets/global/plugins/jquery-inputmask/jquery.inputmask.bundle.min.js',
            'assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
            'assets/src-noconflict/ace.js',
            'assets/more/script/fixHeightContent.js'
        ], 'infopublic', function () {
            this_sav.tableInfoPublic();
            this_sav.TreeViewLogo();

            editModal.find(".HotLine").inputmask("mask", {
                "mask": "(99)-999-99999999",
                placeholder: ""
            });
        });
    };

    //#region Load Table Select
    tableInfoPublic() {
        var this_sav = this;
        var url = this_sav.pb_func.getBaseUrl() + "api/InfoPublic/load";
        var table = $('#datatable_ajax');
        
        var tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "Name", "className": "dt-center" },
                { "data": "Logo", "className": "dt-center" },
                { "data": "HotLine", "className": "dt-center" },
                { "data": "Email", "className": "dt-center" },
                { "data": "Active", "className": "dt-center" },
                { "data": "Action", "className": "dt-center" },
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditInfoPublicModal').off('click');
                $('.EditInfoPublicModal').click(function () {
                    this_sav.EditInfoPublicModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });

                $('.EditLogoModal').off('click');
                $('.EditLogoModal').click(function () {
                    this_sav.EditLogoModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
                
                $('.ActiveInfoPublicModal').off('click');
                $('.ActiveInfoPublicModal').click(function () {
                    this_sav.Active = $(this).prop('checked');
                    this_sav.ID = $(this).attr('idsp');
                    this_sav.UpdateInfoPublic(this, $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }
    //#endregion Load Table Select

    //#region Modal
    EditInfoPublicModal($event, ID: string, type: string) {
        var this_sav = this;
        var a = $event.currentTarget;
        if (type != 'add') {
            a = $event;
        }
        var tr = $(a).parent().parent().parent();
        this_sav.ID = ID;
        
        var editModal = $('#EditInfoPublicModal');
        if (type == "add") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            this_sav.Name = "";
            this_sav.HotLine = "";
            this_sav.Phone0 = "";
            this_sav.Skype = "";
            this_sav.Email = "";
            this_sav.DiaChi = "";
            this_sav.Title = "Thêm mới Thông tin";
        }
        else if (type == "edit") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.HotLine = row["HotLine"];
            this_sav.Phone0 = row["Phone0"];
            this_sav.Skype = row["Skype"];
            this_sav.Email = row["Email"];
            this_sav.DiaChi = row["DiaChi"];
            this_sav.Title = `Sửa Thông tin "${this_sav.Name}"`;
        }
        else if (type == "del") {
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Xóa Thông tin "${this_sav.Name}"`;
        }

        editModal.find('.HotLine').val(this_sav.HotLine);
        editModal.find('.Phone0').val(this_sav.Phone0);
        this_sav.Action = type;
        this_sav.Active = false;
        $(a).next().click();
    }
    //#endregion Modal

    //#region Add, Edit, Del
    UpdateInfoPublic($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var editModal = $('#EditInfoPublicModal');
        var a = $event.currentTarget;
        if(a == null)
            a = $event;

        this_sav.HotLine = editModal.find('.HotLine').val();
        this_sav.Phone0 = editModal.find('.Phone0').val();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/InfoPublic/Update', 'POST',
            {
                ID: this_sav.ID, Name: this_sav.Name,
                HotLine: this_sav.HotLine, Phone0: this_sav.Phone0,
                Email: this_sav.Email, DiaChi: this_sav.DiaChi, 
                Active: this_sav.Active, Type: type, Skype: this_sav.Skype
            },
            null, function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                var elemNotify = editModal.find('.notifyModal');
                if(type == "updateActive") {
                    elemNotify = $;
                    if (status == 0) {
                        var checked = $(a).prop('checked');
                        $(a).prop('checked', checked !== true);
                    }
                }

                if (status == 0) {
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }

    DeleteInfoPublic($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/InfoPublic/Delete', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 0) {
                    $.notify(mess, { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    $.notify(mess, { globalPosition: 'bottom right', className: 'success' });
                }
                $('#DelInfoPublicModal .close').click();
            });
        });
    }
    //#endregion Add, Edit, Del

    //#region Logo
    EditLogoModal($event, ID: string, type: string) {
        var this_sav = this;
        var treeView = $('#treeViewLogo');
        $('#LinktreeViewLogo').prop('disabled', true);
        var a = $event;
        this_sav.adminService.openLoading1();
        this_sav.ID = ID;
        var row = this_sav.items.filter(function (item) {
            return item["ID"] == ID;
        })[0];
        this_sav.Name = row["Name"];
        this_sav.Logo = this_sav.pb_func.NotImage;
        this_sav.NodeID = "";
        $(a).next().click();
        treeView.jstree(true).refresh();
    }

    TreeViewLogo() {
        var this_sav = this;
        var treeView = $('#treeViewLogo');
        var inputTreeView = $('#LinktreeViewLogo');
        var fileTreeView = $('#FiletreeViewLogo');
        var url = this_sav.pb_func.getBaseUrl() + "api/InfoPublic/Logo";
        this_sav.NodeID = "";
        treeView.jstree({
            "core": {
                "themes": {
                    "responsive": false
                },
                // so that create works
                "check_callback": true,
                'data': {
                    'url': function (node) {
                        return url;
                    },
                    'data': function (node) {
                        return { 'ID': this_sav.ID };
                    },
                    'type': 'POST',
                    'headers': { 'Authorization': this_sav.pb_func.getToken() },
                    'success': function () {
                        this_sav.adminService.closeLoading(function () { });
                    }
                }
            },
            "types": {
                "default": {
                    "icon": "fa fa-folder icon-state-warning icon-lg",
                    "max_depth": 1,
                },
                "file": {
                    "icon": "fa fa-file icon-state-warning icon-lg"
                }
            },
            "contextmenu":{
                'items' : function(node) {
                    var items = $.jstree.defaults.contextmenu.items();
                    items.ccp = false;
    
                    return items;
                }
            },
            "state": { "key": "demo3" },
            "plugins": ["contextmenu", "dnd", "state", "types"]
        });

        treeView.on('changed.jstree', function (e, data) {
            if (this_sav.Logo !== "delete") {
                if (data.node != null) {
                    var id = data.node.id;
                    if(this_sav.NodeID == id)
                        return;

                    this_sav.NodeID = id;

                    fileTreeView.val('');
                    this_sav.FileLogo = null;

                    if (id != 'notSelectNode') {
                        inputTreeView.prop('disabled', false);
                        var href = data.node.a_attr.href;
                        var image = data.node.a_attr.image;
                        inputTreeView.val(href);
                        if (image != null && image != '') {
                            this_sav.Logo = this_sav.LinkOrg + image;
                        }
                        else {
                            this_sav.Logo = this_sav.pb_func.NotImage;
                        }
                    }
                    else {
                        this_sav.Logo = this_sav.pb_func.NotImage;
                        inputTreeView.val('');
                        inputTreeView.prop('disabled', true);
                    }
                }
            }
            else {
                this_sav.Logo = this_sav.pb_func.NotImage;
                inputTreeView.click();
            }
        });

        treeView.on("delete_node.jstree", function (e, data) {
            this_sav.Logo = "delete";
        });
    }

    ChangeLogo($event) {
        if ($('#LinktreeViewLogo').prop('disabled') !== true) {
            var a = $event.currentTarget;
            $(a).find('input[type="file"]').click();
        }
        else {
            alert('Error');
        }
    }

    readLogo($event) {
        var this_sav = this;
        var reader = new FileReader();
        reader.onload = function (ee) {
            this_sav.Logo = reader.result.toString();
        };

        try {
            this_sav.FileLogo = $event.currentTarget.files[0];
            reader.readAsDataURL(this_sav.FileLogo);
        }
        catch (r) {
            this_sav.Logo = this_sav.pb_func.NotImage;
        }
    }

    SaveLogo($event) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var treeView = $('#treeViewLogo');
        var editModal = $('#EditLogoModal');
        var nodes = treeView.jstree('get_selected', true);
        if (nodes.length > 0)
            this_sav.DelLogo = nodes[0].a_attr.image;
        else
            this_sav.DelLogo = "";

        if (this_sav.FileLogo != null) {
            nodes[0].a_attr.image = 'NewImageLinkFor';
        }
        var v = treeView.jstree(true).get_json('#', { flat: true })
        v.splice(0, 1);

        let formData: FormData = new FormData();
        formData.append("ID", this_sav.ID);
        formData.append("Logo", JSON.stringify(v));
        formData.append("DelLogo", this_sav.DelLogo);
        formData.append("FileLogo", this_sav.FileLogo);

        this_sav.pb_func.callAPI('api/InfoPublic/UpdateLogo', 'POST', formData, null,
            function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                if (status == 0) {
                    editModal.find('.notifyModal').notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    treeView.jstree(true).refresh();
                    editModal.find('.notifyModal').notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }
    //#endregion Logo 
}


// WEBPACK FOOTER //
// ./src/app/admin/infopublic/infopublic.component.ts